import * as React from 'react';
import { Http } from '@utils';
import Select, { Props as SelectProps } from '../Select';

export interface Prop extends SelectProps<string> {
  isFilter: boolean
  segment: string,
  setOption?: (value: string) => void,
  isKey?: boolean,
  showOptionTitle?: boolean
}

const { Option } = Select

const Lookup: React.FC<Prop> = ({
  isFilter,
  setOption,
  showOptionTitle = true,
  isKey = true,
  segment,
  ...resetProps
}: Prop) => {
  const [kvList, setKvList] = React.useState<KV[]>([]);
  const [value, setValue] = React.useState();

  const filterOption = (input: any, option: any) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  const handleSelectChange = (option: any) => {
    setValue(option);
    setOption && setOption(option)
  };

  React.useEffect(() => {
    ((async () => {
      const kvs = await Http.get<KV[]>('/erp/elastic/kv', {
        segment,
      });
      setKvList(kvs);
    })());
  }, [segment]);
  return  isFilter ? (<Select {...resetProps}
    value={value}
    showSearch
    filterOption={filterOption}
    onChange={handleSelectChange}
    >
      {
        kvList.map((kv) => {
          return (
            <Option key={kv.k}
                    label={kv.v}
                    value={isKey ? kv.k : kv.v}
                    title={showOptionTitle ? kv.v : ''}>{kv.v}
            </Option>
          )
        })
      }
    </Select>) : (<Select {...resetProps} options={kvList.map(kv => ({ label: kv.v, value: isKey ? kv.k : kv.v, title: showOptionTitle ? kv.v : '' }))} />)
};

export default Lookup;
